import type { TUpdatePersonForm } from '@/_schemas/update-person'
import { UpdatePersonFormSchema } from '@/_schemas/update-person'
import type { TExposedApplicationAggregateDTO } from '@doutorsim/shared/applications'
import type { TExposedFacilityDTO } from '@doutorsim/shared/facilities'
import type { TExposedPersonDTO } from '@doutorsim/shared/persons'
import { zodResolver } from '@hookform/resolvers/zod'
import type { ReactNode } from 'react'
import { useContext } from 'react'
import { FormProvider as _FormProvider, useForm } from 'react-hook-form'
import { EditContext } from '../../_providers/edit'

interface FormProviderProps {
  person: TExposedPersonDTO
  application: TExposedApplicationAggregateDTO
  facility: TExposedFacilityDTO
  children: ReactNode
}

export const FormProvider = ({ person, application, facility, children }: FormProviderProps) => {
  const { isFormEditable } = useContext(EditContext)

  const methods = useForm<TUpdatePersonForm>({
    resolver: zodResolver(UpdatePersonFormSchema),
    shouldUnregister: false,
    defaultValues: {
      application: {
        status: application.status,
        facility: facility,
        person: {
          name: person.name ?? '',
          cpf: person.cpf ?? '',
          email: person.email ?? null,
          phone: person.phone ?? null,
          createdAt: person.createdAt,
        },
      },
    },
    disabled: !isFormEditable || application?.status === 'rejected',
  })

  return <_FormProvider {...methods}>{children}</_FormProvider>
}
